/**
 * Name of this package.
 */
export const PACKAGE_NAME = 'back-in-stock-notification';
